<template>
  <div v-if="visibleCoregs.length" class="vg-coregs">
    <div
      v-for="coreg in visibleCoregs"
      :key="coreg.id || coreg.trackingCode"
      class="vg-coregs__item"
    >
      <label class="vg-coregs__label">
        <input
          type="checkbox"
          class="vg-coregs__checkbox"
          :checked="checkedState[coreg.trackingCode]"
          @change="onToggle(coreg, $event)"
        />
        <span class="vg-coregs__text">{{ coreg.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import { useCoregStore } from "@/store/coreg";

export default {
  name: "Coregs",
  data() {
    return {
      checkedState: {},
      coregsData: [],
    };
  },
  computed: {
    visibleCoregs() {
      return this.coregsData.filter(
        (coreg) => coreg.hidden !== true && !!coreg.trackingCode,
      );
    },
  },
  mounted() {
    // globalConfig is injected by an inline script inside the page template that
    // only executes once that template is mounted. Reading it here (after the
    // mount tick) guarantees the order page coregs are available. Reading it from
    // a computed/created runs during the initial render, before the inline script
    // has run, and caches an empty list on a non-reactive global.
    this.$nextTick(() => {
      const coregs = window.globalConfig?.orderPageCoregs;
      this.coregsData = Array.isArray(coregs) ? coregs : [];

      const store = useCoregStore();
      const checkedState = {};
      for (const coreg of this.coregsData) {
        if (!coreg?.trackingCode) {
          continue;
        }
        // Masked coregs are silently subscribed; visible coregs default to their
        // configured `checked` value (unchecked in the V1 parity model).
        // `register` does not overwrite a value already restored from sessionStorage.
        const defaultChecked =
          coreg.hidden === true ? true : coreg.checked === true;
        store.register(coreg.trackingCode, defaultChecked);
        if (coreg.hidden !== true) {
          checkedState[coreg.trackingCode] =
            !!store._selection[coreg.trackingCode];
        }
      }
      this.checkedState = checkedState;
    });
  },
  methods: {
    onToggle(coreg, event) {
      if (!coreg?.trackingCode) {
        return;
      }
      const checked = event.target.checked;
      this.checkedState = {
        ...this.checkedState,
        [coreg.trackingCode]: checked,
      };
      useCoregStore().setChecked(coreg.trackingCode, checked);
    },
  },
};
</script>

<style scoped>
.vg-coregs {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vg-coregs__label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  line-height: 1.4;
  cursor: pointer;
}

.vg-coregs__checkbox {
  margin-top: 2px;
}

.vg-coregs__text {
  flex: 1;
}
</style>
